import { columns } from './columns'
import createState from '../_defaults/state'
import createGetters from '../_defaults/getters'
import createMutations from '../_defaults/mutations'
import createActions from '../_defaults/actions'

/* -------- CONFIG ----------- */
export const apiEndpoint = '/api/sponsorshipTitle'
export const namespace = 'sponsorshipTitle'
export const clientRoute = '/event/sponsorshipTitle'
export const dependencies = ['event', 'sponsorshipMedia']
export const params = {
  include: 'event,sponsorshipMedia'
}
/* --------------------------- */

/* -------- LABELS ----------- */
const titleColumn = 'title'
const subtitleColumn = 'description'
const infoColumns = ['sortOrder']
/* --------------------------- */

const state = {
  columns,
  apiEndpoint,
  namespace,
  dependencies,
  clientRoute,
  params,
  titleColumn,
  subtitleColumn,
  infoColumns
}

export default {
  namespaced: true,
  state: createState(Object.assign(state, { namespace })),
  getters: createGetters(),
  mutations: createMutations(),
  actions: createActions()
}
